import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en.json";
import ru from "../locales/ru.json";
import srLatn from "../locales/sr-Latn.json";

export const uiLocales = ["sr-Latn", "en", "ru"] as const;
export type UiLocale = (typeof uiLocales)[number];

const stored = (() => {
  try {
    return localStorage.getItem("locale");
  } catch {
    return null;
  }
})();

void i18next.use(initReactI18next).init({
  resources: { "sr-Latn": { translation: srLatn }, en: { translation: en }, ru: { translation: ru } },
  lng: uiLocales.includes(stored as UiLocale) ? (stored as UiLocale) : "sr-Latn",
  fallbackLng: "sr-Latn",
  interpolation: { escapeValue: false },
});

export function setLocale(locale: UiLocale): void {
  try {
    localStorage.setItem("locale", locale);
  } catch {
    // приватный режим, не страшно
  }
  void i18next.changeLanguage(locale);
  document.documentElement.lang = locale.startsWith("sr") ? "sr" : locale;
}

export default i18next;
